import { gsap, ScrollTrigger, ScrollTo } from '../global/gsap';

const initCarouselSlides = (carouselSlides) => {
    const slides = gsap.utils.toArray('.js-carousel');

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: carouselSlides,
            start: 'top top',
            end: `+=${(slides.length - 1) * 100}%`,
            scrub: true,
            pin: true
        }
    });

    slides.forEach((slide, i) => {
        gsap.set(slide, { zIndex: slides.length - i });

        if (i < slides.length - 1) {
            tl.to(slide, {
                yPercent: -100,
                ease: 'none'
            }, i === 0 ? 0 : '>');
        }
    });
};

export { initCarouselSlides as default };
